/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_No_BindingInputs */

const en_ledger_error_no_binding = /** @type {(inputs: Ledger_Error_No_BindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This dossier has no ledger template bound`)
};

const nl_ledger_error_no_binding = /** @type {(inputs: Ledger_Error_No_BindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit dossier heeft geen grootboeksjabloon gekoppeld`)
};

/**
* | output |
* | --- |
* | "This dossier has no ledger template bound" |
*
* @param {Ledger_Error_No_BindingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_no_binding = /** @type {((inputs?: Ledger_Error_No_BindingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_No_BindingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_no_binding(inputs)
	return en_ledger_error_no_binding(inputs)
});